import { createAction, props } from '@ngrx/store';
import { BusCheckList } from '../models/bus-check-list.model';


export const loadBusChecks = createAction('[BusCheck] Load BusChecks');
export const loadBusChecksSuccess = createAction('[BusCheck] Load BusChecks Success', props<{ busChecks: BusCheckList[] }>());
export const addBusCheck = createAction('[BusCheck] Add BusCheck', props<{ busCheck: BusCheckList }>());
export const updateBusCheck = createAction('[BusCheck] Update BusCheck', props<{ busCheck: BusCheckList }>());
export const deleteBusCheck = createAction('[BusCheck] Delete BusCheck', props<{ id: number }>());
export const loadBusChecksFailure = createAction('[BusCheck] Load BusChecks Failure', props<{ error: any }>());

// Botón 1: Master Template - añade preguntas generales a nivel global (solo governance)
export const addMasterTemplate = createAction('[BusCheck] Add Master Template', props<{ busCheck: Partial<BusCheckList> }>());
export const addMasterTemplateSuccess = createAction('[BusCheck] Add Master Template Success');
export const addMasterTemplateFailure = createAction('[BusCheck] Add Master Template Failure', props<{ error: any }>());

// Botón 2: Setup - obtiene datos del master template para un idioma y región
export const setupFromMasterTemplate = createAction('[BusCheck] Setup From Master Template', props<{ language: string; regionId: number }>());
export const setupFromMasterTemplateSuccess = createAction('[BusCheck] Setup From Master Template Success');
export const setupFromMasterTemplateFailure = createAction('[BusCheck] Setup From Master Template Failure', props<{ error: any }>());

// Botón 3: Añadir tema regional
export const addRegionalTopic = createAction('[BusCheck] Add Regional Topic', props<{ busCheck: BusCheckList }>());
export const addRegionalTopicSuccess = createAction('[BusCheck] Add Regional Topic Success');
export const addRegionalTopicFailure = createAction('[BusCheck] Add Regional Topic Failure', props<{ error: any }>());